import React, { useState, useEffect } from "react";
import axios from "axios";
import style from "../../../css/admin/Workshopupload.module.css";
import { motion, AnimatePresence } from "framer-motion";
import { API_BASE_URL, Workshop_Url } from "../../ApiConfig";
import { getSecureToken } from "../../ApisService/apiService";

const ViewWorkshops = () => {
  const [workshops, setWorkshops] = useState([]);
  const [expandedWorkshop, setExpandedWorkshop] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    fetchWorkshops();
  }, []);

  const fetchWorkshops = async () => {
    const { secrettoken, ts } = await getSecureToken();

    try {
      const response = await axios.get(`${API_BASE_URL}workshop_uploads/fetch_workshops.php`, {
            headers: {
            'X-TOKEN': secrettoken,
            'X-TIMESTAMP': ts,
          },
        withCredentials: true,
      });
      setWorkshops(response.data);
    } catch (error) {
      console.error("Error fetching workshops:", error);
    }
  };

  const deleteWorkshop = async (id) => {
    if (!window.confirm("Are you sure you want to delete this workshop?")) return;
    const { secrettoken, ts } = await getSecureToken();

    try {
      await axios.post(`${API_BASE_URL}workshop_uploads/delete_workshop.php`, { id }, {
            headers: {
            'X-TOKEN': secrettoken,
            'X-TIMESTAMP': ts,
          },
        withCredentials: true,
      });
      setWorkshops(workshops.filter(workshop => workshop.id !== id));
    } catch (error) {
      console.error("Error deleting workshop:", error);
    }
  };

  return (
    <div className={style.workshopContainer}>
      {/* <h2>Workshops</h2> */}
      {workshops.length === 0 ? (
        <p className={style.workshopDescription}>No data available</p>
      ) : (
        workshops.map((workshop, index) => (
          <div key={index} className={style.workshopItem}>
            {/* Clickable Title */}
            <div
              className={style.workshopTitle}
              onClick={() =>
                setExpandedWorkshop(expandedWorkshop === index ? null : index)
              }
            >
              {workshop.title}
            </div>

            {/* Expandable Section */}
            <AnimatePresence>
              {expandedWorkshop === index && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  className={style.workshopDetails}
                >
                  {/* Description */}
                  <p className={style.workshopDescription}>
                    {workshop.description}
                  </p>

                  {/* Videos Grid */}
                  {/* <h4>Videos:</h4> */}
                  <div className={style.videoGrid}>
                    {JSON.parse(workshop.video_path || "[]").map((video, i) => (
                      <div
                        key={i}
                        className={style.videoThumbnail}
                        onClick={() =>
                          setSelectedVideo(
                            `${API_BASE_URL}workshop_uploads/workshop_uploads/videos/${video}`
                          )
                        }
                      >
                        <video className={style.videoPreview}>
                          <source
                            src={`${API_BASE_URL}workshop_uploads/workshop_uploads/videos/${video}`}
                            type="video/mp4"
                          />
                        </video>
                        <span className={style.playbuttons}>▶ Play Video</span>
                      </div>
                    ))}
                  </div>

                  {/* Documents List */}
                  <h4 className={style.documenttext}>Documents:</h4>
                  <ul className={style.documentList}>
                    {JSON.parse(workshop.document_path || "[]").map((doc, i) => (
                      <li key={i}>
                        <a
                          href={`${API_BASE_URL}workshop_uploads/workshop_uploads/documents/${doc}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={style.documentLink}
                        >
                          📄 {doc}
                        </a>
                      </li>
                    ))}
                  </ul>

                  {/* Delete Button */}
                  <div className={style.uploadContainer}>

                    <button
                      className={style.deleteButton}
                      onClick={() => deleteWorkshop(workshop.id)}
                    >
                      ❌ Delete
                    </button>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))
      )}

      {/* Video Modal */}
      {selectedVideo && (
        <div className={style.videoModal} onClick={() => setSelectedVideo(null)}>
          <div className={style.videoModalContent} onClick={(e) => e.stopPropagation()}>
            <video controls autoPlay>
              <source src={selectedVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <button className={style.closeButton} onClick={() => setSelectedVideo(null)}>✖ </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewWorkshops;
